import { ChartBarIcon } from "@heroicons/react/24/outline";
import { KanbanSquare, Route, ShieldCheck } from "lucide-react";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Dashboard",
    href: "/coaching/dashboard",
    icon: ChartBarIcon,
    current: false,
    internalName: "coaching_dashboard",
  },
  {
    name: "Member Board",
    href: "/coaching/board",
    icon: KanbanSquare,
    current: false,
    internalName: "coaching_board",
  },
  {
    name: "Learning Paths",
    href: "/coaching/learning-paths",
    icon: Route,
    current: false,
    internalName: "learning_paths_dashboard",
  },
  {
    name: "Reviews",
    href: "/coaching/reviews",
    icon: ShieldCheck,
    current: false,
    internalName: "learning_path_reviews",
  },
];

const coachingConfig = {
  sectionName: "coaching",
  defaultRoute: "/coaching/dashboard",
  navigation,
};

export default coachingConfig;
